import { DIALER_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'dialingSpeed',
  type: 'dataDog',
}

const formatting = {
  format: {
    title: 'Dialer Speed',
    append: '/ms',
  },
}

const keys = {
  componentKeys: [DIALER_METRICS],
  healthKey: 'performance_health',
}

const dialingSpeed = {
  metaData: Object.assign(identifiers, formatting, keys),
}

export { dialingSpeed }
